"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromNestableField = exports.NestableDef = void 0;
const tslib_1 = require("tslib");
const t = tslib_1.__importStar(require("io-ts"));
const BooleanDef_1 = require("./BooleanDef");
const ColorDef_1 = require("./ColorDef");
const DateDef_1 = require("./DateDef");
const EmbedDef_1 = require("./EmbedDef");
const GeoPointDef_1 = require("./GeoPointDef");
const ImageDef_1 = require("./ImageDef");
const IntegrationFieldDef_1 = require("./IntegrationFieldDef");
const LinkDef_1 = require("./LinkDef");
const NumberDef_1 = require("./NumberDef");
const RangeDef_1 = require("./RangeDef");
const RichTextDef_1 = require("./RichTextDef");
const SelectDef_1 = require("./SelectDef");
const SeparatorDef_1 = require("./SeparatorDef");
const TextDef_1 = require("./TextDef");
const TimestampDef_1 = require("./TimestampDef");
exports.NestableDef = t.union([
    BooleanDef_1.BooleanDef,
    ColorDef_1.ColorDef,
    DateDef_1.DateDef,
    EmbedDef_1.EmbedDef,
    GeoPointDef_1.GeoPointDef,
    ImageDef_1.ImageDef,
    IntegrationFieldDef_1.IntegrationFieldDef,
    NumberDef_1.NumberDef,
    RangeDef_1.RangeDef,
    RichTextDef_1.RichTextDef,
    SelectDef_1.SelectDef,
    SeparatorDef_1.SeparatorDef,
    TextDef_1.TextDef,
    TimestampDef_1.TimestampDef,
    LinkDef_1.LinkDef,
]);
function fromNestableField(field) {
    switch (field.type) {
        case "Boolean":
            return (0, BooleanDef_1.fromBooleanField)(field);
        case "Color":
            return (0, ColorDef_1.fromColorField)(field);
        case "Date":
            return (0, DateDef_1.fromDateField)(field);
        case "Embed":
            return (0, EmbedDef_1.fromEmbedField)(field);
        case "GeoPoint":
            return (0, GeoPointDef_1.fromGeoPointField)(field);
        case "Image":
            return (0, ImageDef_1.fromImageField)(field);
        case "IntegrationFields":
            return (0, IntegrationFieldDef_1.fromIntegrationField)(field);
        case "Range":
            return (0, RangeDef_1.fromRangeField)(field);
        case "Number":
            return (0, NumberDef_1.fromNumberField)(field);
        case "StructuredText":
            return (0, RichTextDef_1.fromRichTextField)(field);
        case "Select":
            return (0, SelectDef_1.fromSelectField)(field);
        case "Separator":
            return (0, SeparatorDef_1.fromSeparatorField)(field);
        case "Text":
            return (0, TextDef_1.fromTextField)(field);
        case "Timestamp":
            return (0, TimestampDef_1.fromTimestampField)(field);
        case "Link":
            return (0, LinkDef_1.fromLinkField)(field);
    }
}
exports.fromNestableField = fromNestableField;
